<template>
  <main-content>
    <MoneyRequests></MoneyRequests>
  </main-content>
</template>

<script>
import MainContent from "@/components/main-content";
import MoneyRequests from "@/pages/money-request/money-requests";
export default {
  name: "Get",
  components: { MainContent, MoneyRequests },
};
</script>

<style scoped></style>
